<template>
    <!-- 全屏遮罩 -->
    <transition name="fade">
      <div v-if="visible" class="modal-screen">
        <!-- 弹窗容器 -->
        <div class="modal-box">
          <!-- 标题 -->
          <p class="modal-title">{{ prizeTitle }}</p>
          <!-- 渐变圆圈 + 缩放动画 -->
          <transition name="zoom">
            <div v-if="visible" class="prize-circle">
              <img :src="prizeIcon" alt="prize" class="prize-image" />
            </div>
          </transition>
          <!-- 奖品名称 -->
          <p class="prize-name">{{ prizeName }}</p>
          <!-- 收下按钮 -->
          <van-button round plain @click="close"  style="margin-top: 34px; width: 160px; height: 45px; border: none; color: white; font-size: 18px; background: linear-gradient(to bottom, rgba(255, 119, 83, 1), rgba(242, 66, 24, 1));">{{ $t('收下') }}</van-button>
        </div>
      </div>
    </transition>
  </template>
  
  <script setup>
  import { defineProps, defineEmits } from 'vue';
  
  const props = defineProps({
    visible: { type: Boolean, required: true },
    prizeIcon: { type: String, required: true },
    prizeName: { type: String, default: '' },
    prizeTitle: { type: String, default: '' },
  });
  const emit = defineEmits(['update:visible']);
  
  function close() {
    emit('update:visible', false);
  }
  </script>
  
  <style scoped>
  .modal-screen {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  .modal-box {
    background: transparent;
    padding: 16px;
    text-align: center;
    width: 280px;
  }
  .modal-title {
    font-size: 24px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 12px;
  }
  .prize-circle {
    width: 160px;
    height: 160px;
    margin: 0 auto;
    border-radius: 50%;
    background: linear-gradient(#8477FF, #76B4FE);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .prize-image {
    width: 50%;
    height: 50%;
    object-fit: fill;
  }
  .prize-name {
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    margin: 12px 0;
  }
  /* 淡入淡出 */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter-from, .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-to, .fade-leave-from {
    opacity: 1;
  }
  /* 缩放动画 */
  .zoom-enter-active {
    animation: zoomIn 0.5s ease-out;
  }
  @keyframes zoomIn {
    0% { transform: scale(0); opacity: 0; }
    60% { transform: scale(1.2); opacity: 1; }
    100% { transform: scale(1); opacity: 1; }
  }
  </style>
  